/* LAYOUT */
export const CHANGE_LOCATION = 'CHANGE_LOCATION';
export const CHANGE_APPOINTMENT = 'CHANGE_APPOINTMENT';
export const TO_DO = 'TO_DO';
export const FETCH_TODOS_REQUEST = 'FETCH_TODOS_REQUEST';
export const FETCH_TODOS_SUCCESS = 'FETCH_TODOS_SUCCESS';
export const FETCH_TODOS_FAILURE = 'FETCH_TODOS_FAILURE';
